import cookieManager from './cookieManager';
import { ACTIVE_EXPERIMENTS } from './experiments';

const experimentManager = {
  ACTIVE_EXPERIMENTS,
  ...cookieManager,
};

export default experimentManager;
